import React from "react";
import { TextField, InputAdornment } from "@mui/material";

const PercentInput = ({ value, onChange, onBlur, disabled, fullWidth, placeholder, error, helperText }) => {
  return (
    <TextField
      value={value ?? ""}
      onChange={(e) => {
        const raw = e.target.value;
        if (raw === "") return onChange("");
        const cleaned = raw.replace(/[^0-9.-]/g, "");
        const num = Number(cleaned);
        onChange(Number.isNaN(num) ? "" : num);
      }}
      onBlur={onBlur}
      placeholder={placeholder}
      disabled={disabled}
      fullWidth={fullWidth}
      error={error}
      helperText={helperText}
      InputProps={{
        endAdornment: <InputAdornment position="end">%</InputAdornment>,
      }}
      inputProps={{ inputMode: "decimal" }}
    />
  );
};

export default PercentInput;
